import React, { useContext, useState, useEffect } from 'react';
import {
  ListItem,
  ListItemIcon,
  ListItemText,
  Avatar,
  Menu,
  MenuItem,
  Divider,
  List,
  Typography,
  Paper,
  Stack,
} from '@mui/material';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import PersonIcon from '@mui/icons-material/Person';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import LogoutIcon from '@mui/icons-material/Logout';
import GearIcon from '@mui/icons-material/Settings';
import DarkModeToggle from '../DarkModeToggle';
import AdminViewToggle from '../AdminViewToggle';
import LanguagePicker from '../LanguagePicker';
import {
  Business,
  Construction,
  Gavel,
  LocalPolice,
  Quiz,
  ReportProblem,
  SupervisedUserCircle,
} from '@mui/icons-material';
import packageJson from '../../../package.json';
import { toCapitalizeFromUnderScore } from '../../lib/helpers/helpers';
import { PartnerContext } from '../../lib/contexts';
import { UserContext } from '../../lib/contexts';
import { ModeContext } from '../../lib/contexts/ModeContext';
import ArticleIcon from '@mui/icons-material/Article';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import LoginIcon from '@mui/icons-material/Login';
import axios from 'axios';
import { useTheme } from '@mui/material/styles';
import { ThemeContext } from '../../lib/contexts';
import SettingsIcon from '@material-ui/icons/Settings';

export const AvatarMenu = ({ expanded, showTopDivider = true }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const {
    state: { darkMode },
  } = useContext(ThemeContext);

  // Define a reusable sx object for mode styles
  const modeStyles = {
    color: darkMode ? 'white' : 'black',
  };

  const handleAvatarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const {
    actions: { logout },
    state: { userRole },
  } = useContext(UserContext);

  const handleLogout = () => {
    logout();
  };

  const {
    state: { name: partnerName },
  } = useContext(PartnerContext);
  // console.log('here is partner context: ', useContext(PartnerContext));
  const {
    state: { user_name, firstName, lastName, id },
  } = useContext(UserContext);
  //  console.log('here is user context: ', useContext(UserContext));
  //  console.log('is logged in: ', isLoggedIn);
  const initials =
    firstName && lastName
      ? `${toCapitalizeFromUnderScore(firstName?.charAt(0) || '')}${toCapitalizeFromUnderScore(
          lastName?.charAt(0) || '',
        )}`
      : user_name
      ? toCapitalizeFromUnderScore(user_name?.charAt(0))
      : null;

  const { actions, state: modeState } = useContext(ModeContext);

  const navigate = useNavigate();

  const handleLoginRedirect = () => {
    navigate('/login');
  };

  const menuOptions = [
    // isLoggedIn && { icon: <GearIcon sx={modeStyles}/>, text: 'Settings', link: '/settings' },
    // isLoggedIn && { icon: <PersonIcon sx={modeStyles}/>, text: 'My Profile', link: '/profile' },
    // { icon: <HelpOutlineIcon sx={modeStyles}/>, text: 'Need Help?', link: '/help' },
    // { icon: <Quiz sx={modeStyles}/>, text: 'FAQs', link: '/faq' },
    // { icon: <ReportProblem sx={modeStyles}/>, text: 'Status Page', link: '/status' },
    // { icon: <Gavel sx={modeStyles}/>, text: 'Terms of Service', link: '/terms' },
    // { icon: <LocalPolice sx={modeStyles}/>, text: 'Community Guidelines', link: '/guidelines' },

    // { icon: <ArticleIcon sx={modeStyles}/>, text: 'Documentation', link: '/docs' },

    {
      icon: <SettingsIcon sx={{ ...modeStyles, color: 'black' }} />,
      text: 'Account',
      link: '/account',
    },
    {
      icon: <ArticleIcon sx={modeStyles} />,
      text: 'Documentation',
      link: 'https://help.jointangelo.com/',
    },
    // modeState.adminView || !isLoggedIn && { icon: <ArticleIcon sx={modeStyles}/>, text: 'Documentation', link: '/docs' },
    {
      icon: <ArticleIcon sx={modeStyles} />,
      text: 'Terms and Conditions',
      link: 'https://www.jointangelo.com/terms-of-use',
    },
    {
      icon: <ArticleIcon sx={modeStyles} />,
      text: 'Privacy Policy',
      link: 'https://www.jointangelo.com/privacy-policy',
    },
    // {
    //   icon: <ArticleIcon sx={modeStyles} />,
    //   text: 'Contact Us',
    //   link: 'https://www.jointangelo.com/contact',
    // },
    {
      icon: isLoggedIn ? <LogoutIcon sx={modeStyles} /> : <LoginIcon sx={modeStyles} />,
      text: isLoggedIn ? 'Log Out' : 'Log In',
      action: isLoggedIn ? handleLogout : handleLoginRedirect,
    },
  ].filter(Boolean);

  // useEffect(() => {
  //   console.log(`User role changed to: ${userRole}`);

  // }, [userRole]);
  useEffect(() => {
    const interval = setInterval(() => {
      //   console.log(`Current userRole: ${userRole}`);
      //  console.log(theme.palette.primary.main);
    }, 5000);

    return () => clearInterval(interval);
  }, [userRole]);

  useEffect(() => {
    if (id === undefined) {
      setIsLoggedIn(false);
    } else {
      setIsLoggedIn(true);
    }
  }, [id]);

  const theme = useTheme();

  // console.log('here is partner name: ', partnerName);

  return (
    <List sx={{ mt: 'auto' }}>
      {showTopDivider && <Divider />}
      <ListItem
        button
        onClick={handleAvatarClick}
        sx={{ pt: 2 }}
      >
        <ListItemIcon>
          {isLoggedIn ? (
            <Avatar
              sx={{
                bgcolor: theme.palette.primary.main,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {initials}
            </Avatar>
          ) : (
            <PersonOutlineIcon />
          )}
        </ListItemIcon>
        {expanded && (
          <ListItemText
            primary={
              isLoggedIn ? (
                firstName + ' ' + lastName
              ) : (
                <Typography
                  variant="h6"
                  component="div"
                  style={{ marginLeft: '25px' }}
                >
                  Menu
                </Typography>
              )
            }
            secondary={
              isLoggedIn && (
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={modeStyles}
                >
                  <Business
                    fontSize={'10px'}
                    style={{ position: 'relative', top: 1, ...modeStyles }}
                  />
                  &nbsp;{partnerName}
                </Typography>
              )
            }
          />
        )}
      </ListItem>

      <Paper elevation={3}>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          PaperProps={{
            sx: {
              //  width: 320,
              maxHeight: '70vh', // Set maximum height for the menu
              overflowY: 'auto', // Enable vertical scrolling
            },
          }}
        >
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={1}
            sx={{ p: 3 }}
          >
            <ListItemIcon>
              <Avatar
                sx={{
                  bgcolor: theme.palette.primary.main, // Use theme's primary color
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                {initials || <PersonOutlineIcon />}
              </Avatar>
            </ListItemIcon>
            {isLoggedIn && (
              <ListItemText
                primary={<Typography variant="body1">{firstName + ' ' + lastName}</Typography>}
                secondary={
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={modeStyles}
                  >
                    <Business
                      fontSize={'10px'}
                      style={{ position: 'relative', top: 1, ...modeStyles }}
                    />
                    &nbsp;{partnerName}
                  </Typography>
                }
              />
            )}
            {!isLoggedIn && (
              <Typography
                variant="h6"
                component="div"
              >
                Not Signed In
              </Typography>
            )}
            {/* <DarkModeToggle /> */}
          </Stack>
          {menuOptions.map((option) => (
            <MenuItem
              key={option.text}
              onClick={option.action || handleMenuClose}
              component={option.link ? RouterLink : 'div'}
              to={option.link}
              sx={{ py: 1 }}
            >
              <ListItemIcon>{option.icon}</ListItemIcon>
              <ListItemText primary={option.text} />
            </MenuItem>
          ))}
          <Divider />
          <MenuItem>
            <LanguagePicker />
          </MenuItem>
          <MenuItem
            disabled={userRole === 'patient'}
            dense={true}
            key={'userRole'}
            sx={{ py: 1 }}
          >
            {isLoggedIn && (
              <div style={{ paddingRight: '15%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                  <ListItemIcon>
                    <SupervisedUserCircle sx={modeStyles} />
                  </ListItemIcon>
                  <ListItemText primary={`Role: ${toCapitalizeFromUnderScore(userRole)}`} />
                </div>
                {userRole !== 'patient' && (
                  <div style={{ opacity: 0.5, fontSize: '0.7rem', paddingLeft: modeState.adminView ? '10px' : '14px' }}>
                    Viewing as {modeState.adminView ? 'Provider' : 'Patient'}
                  </div>
                )}
              </div>
            )}
            {isLoggedIn && userRole !== 'patient' && <AdminViewToggle />}
          </MenuItem>
          <MenuItem
            disabled={true}
            dense={true}
            key={'version'}
            sx={{ py: 1 }}
          >
            <ListItemIcon>
              <Construction />
            </ListItemIcon>
            <ListItemText primary={`Build: v${packageJson.version}`} />
          </MenuItem>
        </Menu>
      </Paper>
    </List>
  );
};
